export const instrumentationShiftType = {
    Shift: "Shift",
    TimeOff: "TimeOff",
    OpenShift: "OpenShift",
    OpenTimeOff: "OpenTimeOff"
};
